import { ResidencyPermitCrumbs } from './residency-permit-crumbs';

export const ResidencyPermitEditCrumbs = [
  ...ResidencyPermitCrumbs,
  { name: 'Registrazione permesso di soggiorno' },
];
